(function () {
  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function readParams() {
    return new URLSearchParams(window.location.search);
  }

  function writeParams(params) {
    const query = params.toString();
    const nextUrl = query ? `${window.location.pathname}?${query}` : window.location.pathname;
    window.history.replaceState({}, '', nextUrl);
  }

  function uniqueSorted(values) {
    return [...new Set(values.filter(Boolean))].sort((a, b) => a.localeCompare(b, 'pt-BR'));
  }

  function populateSelect(select, values, placeholder) {
    if (!select || select.dataset.dynamic !== 'true') return;

    const current = select.value;
    select.innerHTML = '';

    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = placeholder;
    select.appendChild(defaultOption);

    values.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });

    if (current && values.includes(current)) {
      select.value = current;
    }
  }

  function cardMatches(card, filters) {
    return Object.entries(filters).every(([key, value]) => {
      if (!value) return true;

      const datasetKey = key.replace(/_/g, '-');
      const raw = card.dataset[datasetKey] || '';
      const values = raw.split(',').map((item) => normalize(item));

      if (key === 'atende_online') {
        return raw === value;
      }

      if (key === 'estado' || key === 'cidade' || key === 'estilo' || key === 'tipo_ambiente' || key === 'profissional') {
        return normalize(raw) === normalize(value);
      }

      return values.includes(normalize(value));
    });
  }

  function sortCards(cards, sortValue) {
    return [...cards].sort((a, b) => {
      if (sortValue === 'name') {
        return (a.dataset.name || '').localeCompare(b.dataset.name || '', 'pt-BR');
      }

      if (sortValue === 'location') {
        const left = `${a.dataset.cidade || ''}${a.dataset.estado || ''}`;
        const right = `${b.dataset.cidade || ''}${b.dataset.estado || ''}`;
        return left.localeCompare(right, 'pt-BR');
      }

      const leftOrder = Number(a.dataset.ordem || 9999);
      const rightOrder = Number(b.dataset.ordem || 9999);
      if (leftOrder !== rightOrder) return leftOrder - rightOrder;
      return (a.dataset.name || '').localeCompare(b.dataset.name || '', 'pt-BR');
    });
  }

  function initDirectory(root) {
    const cards = [...root.querySelectorAll('.js-pro-card')];
    const grid = root.querySelector('.js-pro-grid');
    const countEl = root.querySelector('.js-pro-count');
    const emptyEl = root.querySelector('.js-pro-empty');
    const clearBtn = root.querySelector('.js-pro-clear');
    const sortSelect = root.querySelector('.js-pro-sort');
    const filterSelects = [...root.querySelectorAll('[data-filter]')];

    if (!cards.length || !grid) return;

    const filterKeys = filterSelects.map((select) => select.dataset.filter);
    const optionMap = {};

    filterKeys.forEach((key) => {
      if (key === 'atende_online') return;

      optionMap[key] = uniqueSorted(
        cards.flatMap((card) => {
          const datasetKey = key.replace(/_/g, '-');
          const raw = card.dataset[datasetKey] || '';
          if (key === 'estado' || key === 'cidade' || key === 'estilo' || key === 'tipo_ambiente' || key === 'profissional') {
            return raw ? [raw] : [];
          }
          return raw.split(',').map((item) => item.trim()).filter(Boolean);
        })
      );
    });

    filterSelects.forEach((select) => {
      if (select.dataset.filter === 'atende_online') return;
      populateSelect(select, optionMap[select.dataset.filter] || [], select.dataset.placeholder || 'Todos');
    });

    function currentFilters() {
      const filters = {};
      filterSelects.forEach((select) => {
        filters[select.dataset.filter] = select.value;
      });
      return filters;
    }

    function applyFilters(fromUrl) {
      const params = readParams();
      const filters = currentFilters();

      if (fromUrl) {
        filterSelects.forEach((select) => {
          const value = params.get(select.dataset.filter);
          if (value) select.value = value;
        });
        if (sortSelect && params.get('sort')) {
          sortSelect.value = params.get('sort');
        }
      }

      const activeFilters = currentFilters();
      const sortValue = sortSelect ? sortSelect.value : 'relevance';
      const sortedCards = sortCards(cards, sortValue);

      sortedCards.forEach((card) => grid.appendChild(card));

      let visibleCount = 0;
      cards.forEach((card) => {
        const visible = cardMatches(card, activeFilters);
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (countEl) {
        countEl.textContent = `${visibleCount} ${visibleCount === 1 ? 'resultado encontrado' : 'resultados encontrados'}`;
      }

      if (emptyEl) {
        emptyEl.hidden = visibleCount > 0;
      }

      if (!fromUrl) {
        const nextParams = new URLSearchParams();
        Object.entries(activeFilters).forEach(([key, value]) => {
          if (value) nextParams.set(key, value);
        });
        if (sortSelect && sortSelect.value && sortSelect.value !== 'relevance') {
          nextParams.set('sort', sortSelect.value);
        }
        writeParams(nextParams);
      }
    }

    filterSelects.forEach((select) => {
      select.addEventListener('change', () => applyFilters(false));
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', () => applyFilters(false));
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        filterSelects.forEach((select) => {
          select.value = '';
        });
        if (sortSelect) sortSelect.value = 'relevance';
        applyFilters(false);
      });
    }

    applyFilters(true);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.inusual-pro-directory').forEach(initDirectory);
    document.querySelectorAll('.inusual-pro-projects').forEach(initDirectory);
  });
})();
